/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2023 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class accountingperiod extends IceEntity {
  accounting_period_key: string = "";
  next_accounting_period_key: string = "";
  prev_accounting_period_key: string = "";
  basis: IceTypes.basis_of_accounting = IceTypes.basis_of_accounting.boaCash;
  status: IceTypes.period_status = IceTypes.period_status.psCreated;
  title: string = "";
  start_date: any = NaN;
  end_date: any = NaN;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  constructor(copy?: accountingperiod) {
    super();
    this.copy(copy);
  }

  gettablename(): string {
    return "ACCOUNTING_PERIOD";
  }

  copy(cpy?: accountingperiod) {
    if (cpy != null) {
      this.accounting_period_key = cpy.accounting_period_key;
      this.next_accounting_period_key = cpy.next_accounting_period_key;
      this.prev_accounting_period_key = cpy.prev_accounting_period_key;
      this.basis = cpy.basis;
      this.status = cpy.status;
      this.title = cpy.title;
      this.start_date = cpy.start_date;
      this.end_date = cpy.end_date;
      this.record_version = cpy.record_version;
      this.offline_record_status = cpy.offline_record_status;
      this.accessed = cpy.accessed;
      this.accessed_user = cpy.accessed_user;
      this.created = cpy.created;
      this.created_user = cpy.created_user;
      this.modified = cpy.modified;
      this.modified_user = cpy.modified_user;
    }
  }
}
